import React from 'react';
import { ContentsSettingDataResponse } from '@display-component/shared';
import { Box } from '@design-system/pc';
import { LoadImage } from '@display-component/pc';
import { AgentWithAgency } from '@remodeling/shop';
import dynamic from 'next/dynamic';
import styled from 'styled-components';
import ResponsiveBox from '@/components/ResponsiveBox/ResponsiveBox';
import ExpertProfile from './ExpertProfile';
import useExpertDetail from './hooks/useExpertDetail';
import { getAsset } from '@/utils';
import TrackingService from '@/services/tracking';

export interface ExpertDetailProps {
  detailData: AgentWithAgency;
  constructionCaseData: ContentsSettingDataResponse[] | [];
}

const AgencyInformation = dynamic(() => import('./AgencyInformation'));
const StickyExpertProfile = dynamic(() => import('./StickyExpertProfile'));

const ExpertDetail = ({
  detailData,
  constructionCaseData,
}: ExpertDetailProps) => {
  const {
    isShowSticky,
    profileAreaRef,
    handleRequestConsult,
    goList,
    isBestRD,
  } = useExpertDetail({
    detailData,
  });

  return (
    <Box
      {...TrackingService.tagGTM('expert_detail', {
        'expert-id': detailData.agentDetail.code,
      })}
    >
      {isShowSticky && (
        <StickyExpertProfile
          isBestRD={isBestRD}
          expertId={detailData.agentDetail.code}
          imageUrl={detailData.agentDetail.image?.url}
          name={detailData.agentDetail.name}
          duty={detailData.agentDetail.duty}
          handleRequestConsult={handleRequestConsult}
        />
      )}

      <ExpertProfile
        data={detailData.agentDetail}
        handleRequestConsult={handleRequestConsult}
        isBestRD={isBestRD}
        profileAreaRef={profileAreaRef}
        constructionCaseData={constructionCaseData}
      />

      <AgencyInformation data={detailData.agency} />

      <StyledResponsiveBox
        mt={64}
        mb={160}
        onClick={goList}
        {...TrackingService.tagGTM('expert_detail_go_list_button')}
      >
        <LoadImage
          width="100%"
          src={`${getAsset(
            '/assets/images/expert/expert_pc_detail_banner.png',
          )}`}
        />
      </StyledResponsiveBox>
    </Box>
  );
};

export default ExpertDetail;

const StyledResponsiveBox = styled(ResponsiveBox)`
  cursor: pointer;
`;
